<template>
  <div
    class="panel"
    :class="{ 'panel-floating': floating !== false }"
  >
    <div class="panel-header">
      <component :is="titleTag">
        {{ title }}
      </component>

      <SvgIcon
        name="components/close"
        width="16"
        height="16"
        @click="close"
      />
    </div>

    <div class="panel-body">
      <slot />
    </div>
  </div>
</template>

<script>
import SvgIcon from 'vue-svgicon/dist/components/svgicon.common'

import '../../icons/components/close'

export default {
  components: {
    SvgIcon,
  },

  props: {
    /**
     * Text content to place in the title
     */
    title: {
      type: String,
      required: true,
    },

    /**
     * Specify the HTML tag to render instead of the default tag for the title
     */
    titleTag: {
      type: String,
      default: 'h4',
    },

    floating: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    close (e) {
      /**
       * Event triggered by user interaction. Emitted after the close icon is clicked
       */
      this.$emit('close', e)
    },
  },
}
</script>

<style lang="scss" scoped>


.panel {
  height: 1024px;
  border: 1px solid $gray-200;
  background-color: #fff;
  color: $gray-900 !important;
  padding: 1.5rem 2rem;

  &-floating {
    border-color:  transparent;
    box-shadow: 0 2px 16px 0 rgba(37, 37, 37, 0.16), 0 0 8px 0 rgba(37, 37, 37, 0.08);
  }

  &-header,
  &-header > * {
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    > * {
      font-size: $font-size-lg !important;
      font-weight: normal !important;
      font-stretch: normal !important;
      font-style: normal !important;
      line-height: 1.4 !important;
      letter-spacing: normal !important;
      margin-bottom: 0;
    }

    .svg-icon {
      cursor: pointer;
    }
  }

  &-body {
    font-size: $font-size-base;
    line-height: 1.5;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
  }
}
</style>
